import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function noop(): void {
  /* intentionally blank */
}

export function formatNumber(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—';
  return new Intl.NumberFormat('en-US').format(n);
}

export function truncate(s: string | null | undefined, max = 80): string {
  if (!s) return '';
  return s.length > max ? `${s.slice(0, max - 1)}…` : s;
}

/**
 * Convert WordPress-sourced HTML (titles with entities, excerpts wrapped in
 * `<p>`, etc.) to display-ready plain text. Strips tags AND decodes entities
 * in one DOM round-trip; idempotent on already-plain input.
 *
 * For full post body rendering use DOMPurify on the raw HTML — this helper
 * is for list cells and headers where we want a clean one-liner.
 */
export function plainText(html: string | null | undefined): string {
  if (!html) return '';
  // Browser-only API; the admin SPA is browser-only so this is safe here.
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return (doc.body.textContent ?? '').replace(/\s+/g, ' ').trim();
}
